// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCQpSignatureModelTab } from './tCQpSignatureModelTab.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Tab Group
*/
export class TCQpSignatureModelTabGroup {
    /**
    * @description Name
    */
    'name': string;
    /**
    * @description Value
    */
    'value': string;
    /**
    * @description Tabs
    */
    'tabs': Array<TCQpSignatureModelTab>;
    /**
    * @description Role
    */
    'role': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCQpSignatureModelTabGroup>> = [
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "value",
            "baseName": "value",
            "type":     "string"
        },
        {
            "name":     "tabs",
            "baseName": "tabs",
            "type":     "Array<TCQpSignatureModelTab>"
        },
        {
            "name":     "role",
            "baseName": "role",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCQpSignatureModelTabGroup.attributeTypeMap;
    }
}
